// A host's or sponsor's papers on the case (API docs/reminders-and-parties.md,
// migration 031), the emails customers now get at each stage and on the
// dates they asked for, and "Finish later": in the case's words. Free of
// React so the tests read it directly.

export const PARTIES = ["host", "sponsor"];
export const PARTY_TITLES = { host: "Host’s papers", sponsor: "Sponsor’s papers" };
const WHO = { host: "host", sponsor: "sponsor" };

/** How far a party got: { onFile, byParty, total, requiredLeft }. */
export function papersCount(papers = []) {
  return {
    onFile: papers.filter((p) => p.on_file).length,
    byParty: papers.filter((p) => p.by_party).length,
    total: papers.length,
    requiredLeft: papers.filter((p) => p.required && !p.on_file).length,
  };
}

/** One paper's state, for the chip: { label, tone }. */
export function paperState(paper, party) {
  if (paper.on_file && paper.by_party) return { label: `Uploaded by the ${WHO[party] || "host"}`, tone: "pass" };
  if (paper.on_file) return { label: "On file (from the customer)", tone: "pass" };
  if (paper.required) return { label: "Missing", tone: "warn" };
  return { label: "Not given (if it applies)", tone: "skip" };
}

/** The parties the case shows: [["host", { papers, link }], …], only those the visa asks something of. */
export const partiesOf = (caseData) => PARTIES.filter((p) => caseData?.parties?.[p]?.papers?.length).map((p) => [p, caseData.parties[p]]);

const STAGE_WORDS = { checked: "file checked", filed: "application filed", booked: "appointment booked" };
const REMINDER_WORDS = { opens: "the first day to apply", book_by: "the date we aim to book by", submit_by: "the date to submit by" };

// Emails beyond the status, by kind: the title when sent.
const EMAILS = {
  stage_update: (d) => `Emailed the customer: ${(d.stages || []).map((s) => STAGE_WORDS[s] || s).join(", ") || "where it stands"}`,
  date_reminder: (d) => `Reminded the customer of ${REMINDER_WORDS[d.reminder] || "a date they asked for"}`,
  finish_later: () => "Emailed the customer a link to finish later",
  host_link: () => "Emailed the host their link",
  host_reminder: () => "Reminded the host",
  sponsor_link: () => "Emailed the sponsor their link",
  sponsor_reminder: () => "Reminded the sponsor",
  host_not_started: () => "Told the customer their host hasn’t started",
  sponsor_not_started: () => "Told the customer their sponsor hasn’t uploaded their papers",
};

/**
 * The timeline's words for these events: { title, failed?, who? } or null
 * for an event this module doesn't word.
 */
export function partyEvent(type, d = {}) {
  if (type === "party_upload") {
    const who = d.party === "sponsor" ? "Sponsor" : "Host";
    return { title: `${who} uploaded: ${d.name || "a paper"}${d.travellers > 1 ? ` (for ${d.travellers} travellers)` : ""}`, who };
  }
  if (type === "email" && EMAILS[d.kind]) {
    const words = EMAILS[d.kind](d);
    return d.sent ? { title: words } : { title: `Email failed: ${words.replace(/^\w/, (c) => c.toLowerCase())}`, failed: true };
  }
  return null;
}
